import { createExtractedMessagesGetter } from '@lib/i18n'

import enCA from '../i18n/extracted/en-CA.json'
import enUS from '../i18n/extracted/en-US.json'
import frCA from '../i18n/extracted/fr-CA.json'

/**
 * Get the extracted (source) i18n messages for the provided locale.
 *
 * Synchronous — use in tests, Storybook, and app message merging.
 * For production use with compiled AST messages, use `getCompiledI18nMessages`.
 */
export const getExtractedI18nMessages = createExtractedMessagesGetter(
  { 'en-CA': enCA, 'en-US': enUS, 'fr-CA': frCA },
  'en-CA'
)
